// extracted by mini-css-extract-plugin
export default {"component":"b3gYaf","content":"c3gYaf","contentExtra-limitedContent":"d3gYaf","component-fullPage":"e3gYaf","content-fullPage":"f3gYaf"};